import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from './base-api.service';
import { Site } from '../models/site.model';

@Injectable({ providedIn: 'root' })
export class SiteService extends BaseApiService<Site> {
  private readonly collection = 'sites';
  constructor(http: HttpClient) { super(http); }

  getAll() { return this.getAllRaw(this.collection); }
  getById(id: string) { return this.getByIdRaw(this.collection, id); }
  create(item: Site) { return this.createRaw(this.collection, item); }
  update(id: string, item: Partial<Site>) { return this.updateRaw(this.collection, id, item); }
  delete(id: string) { return this.deleteRaw(this.collection, id); }
}
